import React, { useEffect } from 'react'
import { FormProvider, useForm, useWatch } from 'react-hook-form'

import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
} from '@chakra-ui/react'

import { Checkbox, Input, Select } from '@/components/Form'

import useUser from '@/features/users/useUser'
import { useContributorGroup } from '../useContributorGroup'

const ContributorGroupDetailModal = ({ modalDetail, setModalDetail }) => {
  // Redux
  const { show, detail, isCreate } = modalDetail

  // Hook
  const { useFetchAllUsers, useUserOptions } = useUser()
  const { useCreateContributorGroup, useUpdateContributorGroup } = useContributorGroup()
  const updateContributorGroup = useUpdateContributorGroup()
  const createContributorGroup = useCreateContributorGroup()
  const methods = useForm()
  const type = useWatch({ name: 'type', control: methods.control })

  const { data: userOptions } = useUserOptions({ status: 'active', valueKey: '_id' })

  useEffect(() => {
    methods.reset(detail)
  }, [detail, methods])

  // Handler

  const closeModal = () => {
    methods.reset({})

    setModalDetail({
      show: false,
      detail: {},
    })
  }

  const onSubmit = (data) => {
    if (isCreate) {
      console.log('data', data)
      createContributorGroup.mutate(data)
    } else {
      const id = detail._id
      if (!id) {
        return
      }
      updateContributorGroup.mutate({ id, data })
    }

    closeModal()
  }

  return (
    <Modal isOpen={show} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent maxW={'30%'}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <ModalHeader>{isCreate ? 'Add' : 'Update'} Contributor Group</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <VStack>
                <Input label="Code" name="type" isRow disabled={false} />
                <Input label="Name" name="name" isRequired={true} isRow />
                <Select name="defaultUser" label="Default Users" options={userOptions} isRow />
                <Checkbox name="requiredInOffer" label="Required In Offer" isRow />
              </VStack>
            </ModalBody>

            <ModalFooter>
              <HStack>
                <Button colorScheme="green" type="submit">
                  {isCreate ? 'Add' : 'Update'}
                </Button>

                <Button colorScheme="gray" onClick={closeModal}>
                  Close
                </Button>
              </HStack>
            </ModalFooter>
          </form>
        </FormProvider>
      </ModalContent>
    </Modal>
  )
}

export default ContributorGroupDetailModal
